import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { RouterProvider } from 'react-router-dom'
import { store } from './store'
import { router } from './router'
import '../ui/brand/gameFont.css'
import '../ui/brand/gameTokens.css'
import '../ui'
import './app.css'
import { platform, vkLaunchParams } from '../platform/detect'
import { canStartVkLogin } from '../platform/vkEntry'

// Notify the VK host even when a saved game session skips PlatformEntry.
// SDK failure must not block normal play; monetization checks capabilities separately.
if (platform() === 'vk' && canStartVkLogin(vkLaunchParams())) {
  void import('../platform/vk').then(async ({ vkSdk }) => (await vkSdk()).init()).catch(() => undefined)
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Provider store={store}>
      <RouterProvider router={router} future={{ v7_startTransition: true }} />
    </Provider>
  </React.StrictMode>,
)
